import classNames from 'classnames'
import React from 'react'

import Icon, {Icons} from '../icons/Icon'

type CardType = 'default' | 'primary'
interface StatisticsCardProps {
  icon: Icons;
  quantity: string;
  description: string;
  className?: string;
  type?: CardType;
}

const StatisticsCard = ({
  icon,
  quantity,
  description,
  type = 'default',
  className
}: StatisticsCardProps) => {
  const wrapperClasses = classNames('min-w-[216px] min-h-[200px] rounded-2xl text-center flex items-center justify-center p-6', {
    'bg-kwota-neutral-100 border border-kwota-neutral-300': type === 'default',
    'bg-kwota-primary-600': type === 'primary'
  })

  const iconWrapperClasses = classNames(
    'flex items-center justify-center mx-auto rounded-full',
    {
      'bg-kwota-primary-100 p-2 w-max': type === 'default',
      'w-[34px]': type === 'primary'
    }
  )

  const iconClasses = classNames({
    'fill-kwota-primary-500': type === 'default',
    'fill-kwota-neutral-100': type === 'primary'
  })

  const iconSize = type === 'default' ? 'lg' : 'full'

  const titleWrapperClasses = classNames({
    'mt-4': type === 'default',
    'mt-6': type === 'primary'
  })

  const titleClasses = classNames(' font-inter', {
    'text-kwota-primary-500 text-[40px] leading-[48px] font-bold': type === 'default',
    'text-kwota-neutral-100 text-[36px] leading-8 font-semibold': type === 'primary'
  })

  const descriptionWrapperClasses = classNames({
    'mt-1': type === 'default',
    'mt-2': type === 'primary'
  })

  const descriptionClasses = classNames('leading-6 font-inter', {
    'text-kwota-neutral-800 text-base': type === 'default',
    'text-kwota-neutral-100 text-xl': type === 'primary'
  })

  return (
    <div className={`${wrapperClasses} ${className}`}>
      <div>
        <div className={iconWrapperClasses}>
          <Icon icon={icon} className={iconClasses} size={iconSize} />
        </div>
        <div className={titleWrapperClasses}>
          <span className={titleClasses}>{quantity}</span>
        </div>
        <div className={descriptionWrapperClasses}>
          <p className={descriptionClasses}>{description}</p>
        </div>
      </div>
    </div>
  )
}

export default StatisticsCard
